var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 650,
    viewBox: "0 0 1024 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3042_75609)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 650,
    fill: "#D8DBE6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter0_dif_3042_75609)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M794.5 715C759.987 715 726.249 704.766 697.553 685.591C668.857 666.417 646.491 639.164 633.283 607.278C620.076 575.393 616.62 540.306 623.353 506.457C630.086 472.607 646.706 441.514 671.11 417.11C695.514 392.706 726.607 376.086 760.457 369.353C794.306 362.62 829.393 366.076 861.278 379.283C893.164 392.491 920.417 414.857 939.591 443.553C958.766 472.249 969 505.987 969 540.5C969 586.78 950.615 631.165 917.89 663.89C885.165 696.615 840.78 715 794.5 715Z",
    fill: "url(#paint0_linear_3042_75609)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter1_dif_3042_75609)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M730 295C695.586 295 661.945 284.795 633.331 265.676C604.717 246.556 582.415 219.381 569.245 187.587C556.075 155.793 552.63 120.807 559.343 87.0543C566.057 53.3016 582.629 22.2978 606.963 -2.03652C631.298 -26.3708 662.302 -42.9427 696.054 -49.6566C729.807 -56.3704 764.793 -52.9246 796.587 -39.755C828.381 -26.5853 855.556 -4.28331 874.676 24.3308C893.795 52.945 904 86.5861 904 121C904 167.148 885.668 211.405 853.037 244.037C820.405 276.668 776.148 295 730 295Z",
    fill: "url(#paint1_linear_3042_75609)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter2_dif_3042_75609)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M929.5 347C908.832 347 888.628 340.871 871.443 329.389C854.258 317.906 840.864 301.585 832.955 282.49C825.045 263.396 822.976 242.384 827.008 222.113C831.04 201.842 840.993 183.222 855.607 168.607C870.222 153.993 888.842 144.04 909.113 140.008C929.384 135.976 950.396 138.045 969.49 145.955C988.585 153.864 1004.91 167.258 1016.39 184.443C1027.87 201.628 1034 221.832 1034 242.5C1034 270.215 1022.99 296.795 1003.39 316.393C983.795 335.99 957.215 347 929.5 347Z",
    fill: "url(#paint2_linear_3042_75609)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dif_3042_75609",
    x: 596,
    y: 342,
    width: 397,
    height: 397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3042_75609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3042_75609",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3042_75609"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect3_foregroundBlur_3042_75609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dif_3042_75609",
    x: 532,
    y: -77,
    width: 396,
    height: 396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3042_75609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3042_75609",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3042_75609"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect3_foregroundBlur_3042_75609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dif_3042_75609",
    x: 801,
    y: 114,
    width: 257,
    height: 257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3042_75609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3042_75609",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3042_75609"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect3_foregroundBlur_3042_75609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3042_75609",
    x1: 643.581,
    y1: 456.787,
    x2: 945.419,
    y2: 624.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3042_75609",
    x1: 579.514,
    y1: 37.527,
    x2: 880.486,
    y2: 204.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3042_75609",
    x1: 839.122,
    y1: 192.368,
    x2: 1019.88,
    y2: 292.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3042_75609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 650,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background-2.3e3eb978dea974445bee9f786ae14100.svg";
export { ForwardRef as ReactComponent };